module.exports = __webpack_public_path__ + "OpenSans-Italic.e487b7cb072550896dde.eot";


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/node_modules/npm-font-open-sans/fonts/Italic/OpenSans-Italic.eot
// module id = ../../../../npm-font-open-sans/fonts/Italic/OpenSans-Italic.eot
// module chunks = styles